import React from "react";
import "./KnowledgeHub2.css";

const KnowledgeHub1 = () => {
  const articles = [
    {
      id: 1,
      title: "How to make a website look more attractive with llustrations",
      description:
        "Runway heading towards a streamlined cloud solution. User generated content in real-time will have multiple touchpoints for offshoring.",
      date: "23 September 2025",
      type: "large",
    },
    {
      id: 2,
      title: "8 Rules of Thumb in UI Design",
      description:
        "Bring to the table win-win survival strategies to ensure proactive domination.",
      date: "23 September 2025",
      type: "small",
    },
    {
      id: 3,
      title: "How to build strong portfolio and get a Job in UI/UX",
      description:
        "Foster collaborative thinking to further the overall value proposition.",
      date: "23 September 2025",
      type: "small",
    },
  ];

  return (
    <div className="knowledge-hub Onlybottom-border">
      <h2>The Knowledge Hub</h2>
      <h1>Business Valuation Guides & Growth Strategies</h1>
      {/* <p>
      Explore trending topics:
      </p> */}
      <p>
        Explore the latest trends, tips, and expert advice on business
        valuation, growth strategies, and more.
      </p>
      <div className="articles">
        {articles.map((article) => (
          <div key={article.id} className={`article ${article.type}`}>
            <div className="article-content">
              {/* <div>{article.type}</div> */}
              <h3>{article.title}</h3>
              <p>{article.description}</p>
              <span>{article.date}</span>
              <div className="read-more-wrapper">
                <a>Read More</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KnowledgeHub1;
